<template>
    <MainModal 
        :show-modal="showModal" 
        size="sm" 
        :title="`${action === 'add' ? 'New' : 'Edit'} meeting note`" 
        header-text-transform="none"
        @close="onCancel"
    >
        <template #body>
            <div class="modal__wrapper--onboarding">
                <div class="modal--section">
                    <form @submit.prevent="">
                        <FormTextArea 
                            id="noteValue"
                            v-model="noteValue"
                            html-for="noteValue"
                            class="mt--0"
                            required size="sm"
                        />
                    </form>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="w-100 flex justify-content-end align-items-center">
                <BaseButton 
                    class="mr--5" 
                    label="Cancel" 
                    variant="outline" 
                    @submit="onCancel"
                />
                <BaseButton 
                    :loading="loading" 
                    type="submit" 
                    :disabled="!noteValue || loading"
                    :label="`${action === 'add' ? 'Add' : 'Save'} note`" 
                    @submit="handleSubmit"
                />
            </div>
        </template>
    </MainModal>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import FormTextArea from "../input/FormTextArea.vue";
import MainModal from "./MainModal.vue";

export default {
    name: "MeetingNoteModal",

    components: {
        FormTextArea,
        BaseButton,
        MainModal,
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        action: {
            type: String,
            default: "",
        },
        meetingId: {
            type: String,
            default: "",
        },
        currentNote: {
            type: Object,
            default: () => {},
        },
    },

    emits: ["complete", "cancel"],

    data() {
        return {
            noteValue: "",
            loading: false,
        };
    },

    watch: {
        "currentNote"(newVal) {            
            if (newVal) {
                this.noteValue = newVal.value;
            }
        },
    },

    methods: {
        async handleSubmit() {
            try {                
                this.loading = true;
                const dispatchAction = this.action === "add" ? "addNote" : "updateNote";
                
                const result = await this.$store.dispatch(`meeting/${dispatchAction}`, 
                    { 
                        id: this.meetingId,
                        payload: { value: this.noteValue },
                    },
                );
                
                this.$toast.info(`Note ${this.action === "add" ? "added" : "updated"}`);
                this.$emit("complete", result);
                this.onCancel();
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.$toast.error(errMsg);
            } finally {
                this.loading = false;
            }
        },

        onCancel() {
            this.noteValue = "";
            this.$emit("cancel");
        },
    },
};
</script>